import * as React from "react";
import Container from "./styled";
import { Fade } from "react-awesome-reveal";

export default function Asistencia() {
  return (
    <Container>
      <Fade
        delay={100}
        duration={800}
        triggerOnce={true}
        className="ikeContainer"
      >
        <h2>¡Podes sumar más beneficios!</h2>
        <div>
          <img alt="Ike Asistencia Logo" src="images/logos/bicimasike.svg" />
        </div>
        <p>
          A tu SeguroBici. agregale muchos más beneficios de cobertura e
          increibles descuentos en servicios para tu bici. Sumale{" "}
          <a href="https://ikeasistencia.com//" target="_blank">
            Ike Asistencia
          </a>{" "}
          a tu poliza y sentite mas seguro que nunca, comprometidos a brindar
          servicios de excelencia con personal especializado y recursos de
          vanguardia.
        </p>
      </Fade>
    </Container>
  );
}
